import { render, staticRenderFns } from "./vtl-menu.vue?vue&type=template&id=4b24959d"
import script from "./vtl-menu.vue?vue&type=script&lang=js"
export * from "./vtl-menu.vue?vue&type=script&lang=js"
import style0 from "./vtl-menu.vue?vue&type=style&index=0&id=4b24959d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports